import { render, staticRenderFns } from "./addNewCard.vue?vue&type=template&id=15e97e41"
import script from "./addNewCard.vue?vue&type=script&lang=js"
export * from "./addNewCard.vue?vue&type=script&lang=js"
import style0 from "./addNewCard.vue?vue&type=style&index=0&id=15e97e41&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports